import { render } from "./menusEditor.vue?vue&type=template&id=43a3202e"
import script from "./menusEditor.vue?vue&type=script&lang=js"
export * from "./menusEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__